import { HomeField } from 'app/views/home/webgl/particles/fields/HomeField';
import HomeFieldConfig from 'app/views/home/webgl/particles/config/HomeFieldConfig';
import { HomeParticle } from 'app/views/home/webgl/particles/fields/HomeParticle';
import { particles } from 'app/contracts/Particles';
import BaseDepartmentScene from 'app/views/home/webgl/particles/departments/BaseDepartmentScene';
import { device } from 'utils/device';

export default class IntroDepartment extends BaseDepartmentScene {
	private _introParticles: Array<HomeParticle>;
	private _active: boolean = false;
	private _mousedown: boolean = false;
	private _iconParticleContainer: PIXI.Sprite;

	constructor(
		private _homeField: HomeField,
		private _sceneProps: particles.SceneProps
	) {
		super();
		this._iconParticleContainer = this._homeField.getSubContainer('icon');
		this._introParticles = HomeFieldConfig.getParticlePool(this._homeField.particles as Array<HomeParticle>, 'intro');

		window.addEventListener(
			'mousedown',
			() => {
				this._mousedown = true;
			},
			{ passive: true }
		);
	}

	public tick() {
		if (!this._active) return;

		this._positionParticleContainer();

		if (this._mousedown) {
			this._introParticles.forEach((particle) => {
				particle.repell.reducePower(Math.random() * -3);
			});
		}
	}

	private _positionParticleContainer() {
		let x =
			this._sceneProps.progress.containerX +
			this._sceneProps.zonePositions.homeParticles.cx * this._sceneProps.sizes.container.w;
		this._sceneProps.mouse.particleContainersX.home = x;
		this._iconParticleContainer.x = x;
	}

	/** User is far enough right to be on spaces scene */
	public startAsActiveScene() {
		if ((window as any).skipIntroClick) {
			return;
		}

		this._active = true;
		this._setParticlesStartState();
	}

	public stopAsActiveScene() {
		this._active = false;

		return;
		this._introParticles.forEach((particle) => {
			particle.deactivateAllBehaviours(false);
			particle.active = false;
		});
	}

	public introComplete() {
		this._introParticles.forEach((particle, index) => {
			particle.intro.introComplete();
		});
	}

	public mouseOver() {
		this._introParticles.forEach((particle, index) => {
			if (index < 500) {
				particle.intro.mouseOver();
			}
		});
	}

	public mouseOut(maxIndex = 100) {
		this._introParticles.forEach((particle, index) => {
			if (index < 500) {
				particle.intro.mouseOut();
			}
		});
	}

	private _resizeTimeout;

	public resize(): void {
		this._doReszie();
		if (this._resizeTimeout) {
			clearTimeout(this._resizeTimeout);
		}

		this._resizeTimeout = setTimeout(() => {
			this._resizeTimeout = null;
			this._doReszie();
		}, 100);
	}

	private _doReszie() {
		let isMobile = device.innerWidth < 1200;

		this._introParticles.forEach((particle, index) => {

			particle.intro.centerPosition(isMobile);
		});
	}

	/** User has opened at 'home' so just start state as normal */
	public setIntialState(): void {

		let isMobile = device.innerWidth < 1200;
		this._introParticles.forEach((particle, index) => {
			if (index < 500) {
				particle.intro.startState(isMobile);
			}
		});

	}

	//PRIVATE
	//--------------------------------------------------------------------------------------
	//--------------------------------------------------------------------------------------
	//--------------------------------------------------------------------------------------
	//--------------------------------------------------------------------------------------
	//--------------------------------------------------------------------------------------

	//Opening non hover state:
	private _setParticlesStartState(): void {
		this.setIntialState();
	}

}
